var map = {
	"./images/advantages-terminal.png": 2088,
	"./images/banner-1.png": 3566,
	"./images/flag-fr.png": 3169,
	"./images/flag-hy.png": 9177,
	"./images/flag-it.png": 9969,
	"./images/flag-ru.png": 540,
	"./images/flag-usa.png": 772,
	"./images/latest-1.png": 7126,
	"./images/latest-2.png": 2018,
	"./images/partner-1.png": 5184,
	"./images/partner-2.png": 8566,
	"./images/partner-3.png": 8608,
	"./images/partner-4.png": 6890,
	"./images/partner-5.png": 1072,
	"./images/partner-6.png": 3815,
	"./images/partner-7.png": 9187
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2474;